function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSculptIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M2.9 10.4C2.1 9.1 2.5 7.0 4.1 6.1C5.5 5.3 7.0 5.8 7.7 6.8C8.1 7.4 7.8 8.0 8.4 8.5C8.9 8.9 9.6 8.6 10.1 9.1C10.6 9.8 10.3 11.0 9.3 11.8C8.1 12.8 6.6 12.8 5.5 11.9C4.8 11.3 3.6 11.4 2.9 10.4Z",
  style: {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.4 8.0L11.4 3.7C11.8 3.1 12.6 3.0 13.2 3.4C13.7 3.8 13.9 4.6 13.5 5.2L10.4 9.5L8.6 9.9L8.4 8.0Z",
  style: {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4 9.6C11.8 9.9 12.1 10.4 12.1 10.9",
  style: {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8 8.8C13.5 9.4 13.9 10.2 13.9 11.0",
  style: {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSculptIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d730f9018e66f6ac9688fd3b1a4e2b71.svg";